import {Poi} from "src/app/classes/common/poi";
import { Partecipant } from "./partecipant";
import {Utility} from "src/app/classes/common/utility";

export class Waypoint {

  _id: string;
  type: string;
  coordinates: { latitude: number; longitude: number };
  data: string;
  partecipant: Partecipant;
  poi: Poi;
  addressChanged: boolean = false;
  addressValid: boolean = false;

  constructor(data?: any){
    if(data){
      this.setData(data);
    }
  }

  setData(data:any) {
    if(data){
      this._id = Utility.generateRandomKey(24);
      this.type = data.type;
      this.coordinates = data.coordinates;
      this.data = data.data;
      this.partecipant = data.partecipant;
      this.poi = data.poi;
    }
  }

  clean(){
    this.addressChanged = false;
    this.partecipant = null;
    this.poi = null;
    this.data = null;
    this.coordinates = null;
  }

  get isEmpty(): boolean {
    return !(this.partecipant || this.poi || this.data);
  }

  get hasCoordinates(): boolean {
    return (
      this.coordinates !== null &&
      typeof this.coordinates?.latitude === 'number' &&
      typeof this.coordinates?.longitude === 'number'
    );
  }

  get _type(): string{
    switch(this.type){
      case 'poi':
        return 'POI'
      case 'participant':
        return 'Veicolo'
      case 'address':
        return 'Indirizzo'
    }

  }


}
